/*
 * @Author: alan(曹昌盛)
 * @Date: 2020-03-07 16:00:43
 * @Last Modified by:   alan(曹昌盛)
 * @Desc:侧边小工具
 */
import { Props } from './@side_tool_bar'
import './SideToolBar.less'

const SideToolBar = (props: Props): JSX.Element => {
  const { lang, handleShowOnlineService, isInAdmin } = props

  const scrollToTop = () => {
    if (!isInAdmin) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    } else {
      const scrollElement = document.getElementById('content') as HTMLElement
      scrollElement.scrollTop = 0
    }
  }

  return (
    <aside className='side-tool-bar-wrap'>
      { !isInAdmin &&
        <ul>
          {/* <li className='tool-plan'>
            <div>
              <a
                href={`/${lang}/influencer_plan/`}
                target='_blank'
                className='influencerPlan-link'
              >
                <i className='fee-tag'>{__('Free')}</i>
                <strong>{__('Influencer Starter Plan')}</strong>
                <span>{__('Details >')}</span>
              </a>
              <a
                href={`/${lang}/alpha_plan/`}
                target='_blank'
              >
                <strong>{__('Alpha Plan ')}</strong>
                <span>{__('Details >')}</span>
              </a>
            </div>
            <span>{__('Plan')}</span>
          </li> */}
          <li className='tool-bd'>
            <span>{__('BD 101')}</span>
            <a
              target='_blank'
              href={`/${lang}/info_graphic/#/business_mode`}
            >
              <strong>{__('BuckyDrop 101')}</strong>
              <span>{__('Details >')}</span>
            </a>
          </li>
          <li className='tool-service' onClick={handleShowOnlineService}>
            <span>{__('Service')}</span>
          </li>
          <li className='tool-top' onClick={scrollToTop}>
            <span>{__('Top')}</span>
          </li>
        </ul>
      }
      { isInAdmin &&
        <ul>
          <li className='tool-service' id='toolService' onClick={handleShowOnlineService} />
          <li className='tool-top' id='toolTop' onClick={scrollToTop} />
        </ul>
      }
    </aside >
  )
}
export default SideToolBar
